const COLORS = [
  '#0d1320',
  '#49dbea',
  '#f7dc5b',
  '#bb70ff',
  '#58df88',
  '#ff5c7a',
  '#588cff',
  '#ff9d4a',
  '#32445c',
];

const renderCache = new WeakMap<
  HTMLCanvasElement,
  { cells: number[]; width: number; height: number }
>();

export function drawGrid(
  canvas: HTMLCanvasElement,
  cells: readonly number[],
  columns: number,
  rows: number,
): void {
  const ratio = window.devicePixelRatio || 1;
  const rect = canvas.getBoundingClientRect();
  const width = Math.max(1, Math.round(rect.width * ratio));
  const height = Math.max(1, Math.round(rect.height * ratio));
  if (canvas.width !== width || canvas.height !== height) {
    canvas.width = width;
    canvas.height = height;
  }
  const previous = renderCache.get(canvas);
  if (
    previous?.width === width &&
    previous.height === height &&
    equalCells(previous.cells, cells)
  ) {
    return;
  }
  const context = canvas.getContext('2d');
  if (!context) return;
  context.clearRect(0, 0, width, height);
  const cellWidth = width / columns;
  const cellHeight = height / rows;
  cells.forEach((value, index) => {
    const x = index % columns;
    const y = Math.floor(index / columns);
    context.fillStyle = COLORS[value] ?? COLORS[0];
    context.fillRect(
      x * cellWidth + ratio,
      y * cellHeight + ratio,
      cellWidth - ratio * 2,
      cellHeight - ratio * 2,
    );
    context.strokeStyle = value === 8 ? '#7d94ae' : 'rgba(255,255,255,.16)';
    context.lineWidth = ratio;
    context.strokeRect(
      x * cellWidth + ratio,
      y * cellHeight + ratio,
      cellWidth - ratio * 2,
      cellHeight - ratio * 2,
    );
  });
  renderCache.set(canvas, { cells: [...cells], width, height });
}

function equalCells(left: readonly number[], right: readonly number[]): boolean {
  if (left.length !== right.length) return false;
  for (let index = 0; index < left.length; index += 1) {
    if (left[index] !== right[index]) return false;
  }
  return true;
}
